/**
 * Localized messages support class extended with vue-i18n plugin
 */
class Locale {
  #vue;

  use(vueInstance) {
    this.#vue = vueInstance;
  }

  getMessage(key) {
    return this.#vue.$t(key);
  }

  /**
   * Strips html tags like <code>
   */
  getMessageAsText(key) {
    return this.#vue.$t(key).replace(/<.[\w "=']*>/g, '');
  }
}
export default new Locale();
